import * as Types from './actionTypes';

export const initDrivers = (drivers) => ({
  type: Types.INIT_DRIVERS,
  payload: {
    drivers,
  },
});

export const initShippers = (shippers) => ({
  type: Types.INIT_SHIPPERS,
  payload: {
    shippers,
  },
});

export const initShipments = (shipments) => ({
  type: Types.INIT_SHIPMENTS,
  payload: {
    shipments,
  },
});

export const connectRelations = () => ({
  type: Types.CONNECT_RELATIONS,
});

export const fetchDriverDocs = (id) => ({
  type: Types.FETCH_DRIVER_DOCS,
  payload: {
    id,
  },
});

export const driverDocsFetched = (data) => ({
  type: Types.DRIVER_DOCS_FETCHED,
  payload: {
    data,
  },
});

export const approveDriverDoc = (profileId, id, values) => ({
  type: Types.APPROVE_DRIVER_DOC,
  payload: {
    id,
    values,
    profileId,
  },
});

export const driverDocApproved = (doc) => ({
  type: Types.DRIVER_DOC_APPROVED,
  payload: {
    doc,
  },
});

export const rejectDriverDoc = (profileId, id, values) => ({
  type: Types.REJECT_DRIVER_DOC,
  payload: {
    id,
    values,
    profileId,
  },
});

export const driverDocRejected = (doc) => ({
  type: Types.DRIVER_DOC_REJECTED,
  payload: {
    doc,
  },
});

export const assignReferenceId = (values) => ({
  type: Types.ASSIGN_REFERENCE_ID,
  payload: {
    values,
  },
});

export const assignedReferenceId = () => ({
  type: Types.ASSIGNED_REFERENCE_ID,
  payload: {},
});
